<style>
    .details-box__summary {
        cursor: pointer;
    }

    .details-box__toggle-indicator {
        display: inline-block;
        width: 0.8em;
    }
</style>

<template>
    <div class="details-box" data-open="currentlyOpen">
        <span v-if="indicator" ref="indicator" class="details-box__toggle-indicator">{{ currentlyOpen ? '&ndash;' : '+' }}</span>

        <div ref="summary" class="details-box__summary" tabindex="0" @click="toggle" @keydown.enter="toggle" @keydown.space="toggle">
            <slot name="summary" :currentlyOpen="currentlyOpen" />
        </div>

        <!--Use `v-show` instead of `v-if` to support components that change on mount/destroy.-->
        <cp-expander v-show="currentlyOpen" :duration="transitionDuration">
            <slot />
        </cp-expander>
    </div>
</template>

<script>
    import CpExpander from './expander';

    export default {
        model: {
            prop: 'open',
            event: 'change',
        },

        components: {
            CpExpander,
        },

        props: {
            open: Boolean,
            indicator: {type: Boolean, default: true},
            transitionDuration: {type: Number, default: CpExpander.props.duration.default},
        },

        data() {
            return {
                currentlyOpen: this.open,
            };
        },

        mounted() {
            if (this.indicator) {
                this.insertToggleIndicator();
            }
        },

        methods: {
            getFirstNonEmptyTextNode(root) {
                // For A TreeWalker filter, IE needs a functions...
                const filter = node => node.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;

                // ...and everything else takes an object with an `acceptNode` method.
                filter.acceptNode = filter;

                // Also note, the fourth argument is _not_ optional in IE.
                const textNodeWalker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, filter, false);

                return textNodeWalker.nextNode();
            },

            insertToggleIndicator() {
                const firstTextNode = this.getFirstNonEmptyTextNode(this.$refs.summary);
                if (firstTextNode) {
                    firstTextNode.parentNode.insertBefore(this.$refs.indicator, firstTextNode);
                }
            },

            toggle(event) {
                if (document.activeElement === this.$refs.summary) {
                    event.preventDefault();
                    this.currentlyOpen = !this.currentlyOpen;
                }
            },
        },

        watch: {
            open(open) {
                // Reflect changes from outside.
                this.currentlyOpen = open;
            },

            currentlyOpen(currentlyOpen) {
                this.$emit(currentlyOpen ? 'open' : 'close');
                this.$emit('change', currentlyOpen);
            },
        },
    };
</script>
